module.exports = __webpack_public_path__ + "static/img/first3.0c53da8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/first3.png
// module id = k2FX
// module chunks = 25